import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-6" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = { class: "col-lg-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InteractiveRating = _resolveComponent("InteractiveRating")!
  const _component_SettingGettingValues = _resolveComponent("SettingGettingValues")!
  const _component_RTLSupport = _resolveComponent("RTLSupport")!
  const _component_ReadOnlyPresetValue = _resolveComponent("ReadOnlyPresetValue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_InteractiveRating)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_SettingGettingValues)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_RTLSupport)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_ReadOnlyPresetValue)
    ])
  ]))
}